// extracted by mini-css-extract-plugin
export default {"post_review":"Reviews_post_review__Sm4fv","btn":"Reviews_btn__4YHYq","heading":"Reviews_heading__w6dsg"};